/**
 * Testimonials Slider Module
 */

export default function initTestimonialsSlider() {
  const modules = document.querySelectorAll('.testimonials-slider-module');
  if (!modules.length) return;

  modules.forEach(module => {
    const quoteSwiperEl = module.querySelector('.testimonials-quote-swiper');

    if (!quoteSwiperEl ) return;

    new window.Swiper(quoteSwiperEl, {
      modules: [window.SwiperModules.Pagination, window.SwiperModules.Autoplay],
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      autoHeight: true,
      spaceBetween: 24,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.testimonials-pagination',
        clickable: true,
        type: 'bullets'
      }
    });
  });
}

// Auto-initialize
document.addEventListener('DOMContentLoaded', initTestimonialsSlider);
